module.exports = __webpack_public_path__ + "img/a_cuentas_corrientes.2a33ad2e.png";